import "../styles/services.scss";
import { items } from "../services/data.ts";
import { useState } from "react";
import Detail from "./detail_popup.jsx";
const Services = () => {
  const [detail, setDetail] = useState(null)
  return (
    <section id="services" className="services-section">
      <div className="line" />
      <h2>Serviços</h2>
      <div className="service-grid">
        {items.services.map((service, index) => (
          <div className="service-content" id={`service-${index}`}
          onClick={() => {
            setDetail(index);
            setTimeout(() => {
              document.getElementById("detail")?.scrollIntoView({ behavior: "smooth" });
            }, 0);
          }} >

            <img className="service-image-outside" src={service.image} />
            
            <div key={index} className="service-card">
              <img className="service-image-inside" src={service.image} />
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <div className="service-list">
                {service.list.map((item, listIndex) => (
                  <li key={listIndex} className="justify">
                     <span>{item[0]}</span>
                     <>
                     {item[1]}
                     </>
                      </li>  
                ))}
              </div>
            </div>


          </div>
        ))
        }
        {detail?
        <Detail index={detail} />
        :''}
      </div>
    </section >
  )
}

export default Services;